import $ from 'jquery'
import 'jquery-migrate'
import './modules/_skip-link-focus-fix'
import './modules/_foundation-scripts'
import './modules/_mobile-menu'
import './modules/_desktop-menu'
import './modules/_galleries'
import { detect } from 'detect-browser'
import 'jquery-match-height'
import fitty from 'fitty'
import jump from 'jump.js'

/**
 * Notes:
 *
 * Although jQuery is imported above, it is not bundled
 * with the transpiled assets. jQuery needs to be global
 * on the website.
 *
 * All imports belong at the top of the file.
 *
 * Webpack only outputs this one script file, if you need
 * another file then add it to the scripts-list.js file as
 * another line in the scripts_list object.
 *
 * The scripts_list const is imported into the webpack
 * config. I've done this so that you do not have to
 * wade through the config to find what is being
 * compiled out as its own file.
 *
 * When importing node modules that are not ES6 modules,
 * you do not need to path them as '../../node_modules/'.
 * Gulp knows about the node_modules directory, so all you need
 * to do is path them as if you were already in the node_modules
 * directory
 *
 * Instead of:
 * import '../../node_modules/jquery-migrate/dist/jquery-migrate';
 *
 * Use:
 * import 'jquery-migrate/dist/jquery-migrate';
 *
 */

/*************** Template part region toggle button ***************/
$('#theme_debug_regions').on('click', function (event) {
	event.preventDefault()

	$('.placeHolderPosition').slideToggle()
})

/*************** Browser Version ***************/
const browser = detect()
const browser_version = browser.version.split('.')
const browser_html_class = browser.name + '-' + browser_version[0]

$('html').addClass(browser_html_class)

/*************** Match Height ***************/
$('.match-height').matchHeight()

/*************** Header Scroll Anchor ***************/
const site_site_header_height = $('.site-header').height()

$(window).on('scroll', function () {
	const site_quicklinks_height = $('.site-quicklinks').height()

	if ($(this).scrollTop() > site_quicklinks_height) {
		$('.site-header').addClass('fix-header')
		$('.site-body').css('padding-top', site_site_header_height)
	} else {
		$('.site-header').removeClass('fix-header')
		$('.site-body').css('padding-top', 0)
	}
})

/*************** Fit text to container width ***************/
fitty('.sized-width', {
	maxSize: 45,
})

fitty('.sized-width-max-51', {
	maxSize: 51,
})

fitty('.sized-width-max-110', {
	maxSize: 110,
})

/*************** Anchor Scroll ***************/
const anchor_scroll = $('.site-body a[href^=#]').not('.accordion-title').not('.tabs-title a')

anchor_scroll.each((index, link) => {
	$(link).on('click', function (event) {
		event.preventDefault()
		jump($(this).attr('href'), {
			offset: -100,
		})
	})
})

/*************** Site Search ***************/
$('#site_search').on('click', function (event) {
	event.preventDefault()

	$('.site-search-form').slideToggle(400, 'swing', function () {
		$('#wp-block-search__input-1').trigger('focus')
	})
})
